module.exports = __webpack_public_path__ + "img/screen.28ba53b8.svg";